var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-style',{attrs:{"spellcheck":"false"}},[_vm._v(" "+_vm._s(_vm.getOptionsCSSCode)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }